document.addEventListener('DOMContentLoaded', function () {
  const starElements = document.querySelectorAll('.stars-filled');
  
  starElements.forEach(function (starFilled) {
    const ratingValue = parseFloat(starFilled.dataset.rating);
    if (!isNaN(ratingValue)) {
      starFilled.style.width = (ratingValue * 20) + '%'; // 20% per star
    }
  });
});
